const budgetConciliationHeader = [
  {
    group: 'Orçamento BTLeo Líquido',
    columns: [
      {
        name: 'Id',
        id: 'orcamento-id',
        show: false
      },
      {
        name: 'Ano',
        id: 'orcamento-ano',
        show: true
      },
      {
        name: 'Gerente Operacional',
        id: 'orcamento-gp',
        show: false
      },
      {
        name: 'GC',
        id: 'orcamento-gc',
        show: false
      },
      {
        name: 'Empresa',
        id: 'orcamento-empresa',
        show: false
      },
      {
        name: 'Categoria',
        id: 'orcamento-categoria',
        show: false
      },
      {
        name: 'Loja',
        id: 'orcamento-loja',
        show: false
      },
      {
        name: 'Fator Venda Bruta',
        id: 'orcamento-fator-venda',
        show: true
      },
      {
        name: 'Real Ano Anterior',
        id: 'orcamento-real-ano-anterior',
        show: true
      },
      {
        name: 'Orçamento Comercial',
        id: 'orcamento-comercial',
        show: true
      },
      {
        name: '',
        id: 'orcamento-alterado-loja',
        show: true
      },
      {
        name: 'Orçamento Loja',
        id: 'orcamento-orçamento-loja',
        show: true
      },
      {
        name: '',
        id: 'orcamento-alterado-ajustado',
        show: true
      },
      {
        name: 'Orçamento Ajustado',
        id: 'orcamento-ajustado',
        show: true
      },
      {
        name: 'Margem',
        id: 'orcamento-margem',
        show: true
      },
      {
        name: 'Margem (%)',
        id: 'orcamento-margem-perc',
        show: true
      }
    ]
  },
  {
    group: 'Orçamento Dias Úteis',
    columns: [
      {
        name: 'Real Ano Anterior',
        id: 'orcamento-ano-anterior',
        show: true
      },
      {
        name: 'Orçamento Comercial',
        id: 'orcamento-du-comercial',
        show: true
      },
      {
        name: 'Orçamento Loja',
        id: 'orcamento-du-loja',
        show: true
      }
    ]
  }
]

export default budgetConciliationHeader
